/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StatusWorkflowFieldType {
  String = 'STRING',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  Float = 'FLOAT',
  Currency = 'CURRENCY'
}
